import ServiceManager from "../3x1010/services/ServiceManager";

const selectedColors = ['selected-blue','selected-yellow','selected-green','selected-red','selected-purple']; 

const missing = '<i class="fas fa-ban" data-toggle="tooltip" data-placement="top" data-html="true" title="Missing"></i>'
const missing2 = '<span class="" data-toggle="tooltip" data-placement="top" data-html="true" title="Missing"></span>';

const matchTitle='<em>{NomeEx}</em> <br/> <small>Match {MatchNum}/19 features<small/>';

const musei={
  MV:	'Musei Vaticani, Città del Vaticano',
  METorino:	'Fondazione Museo delle Antichità Egizie di Torino',
  RMO:	'Rijksmuseum van Oudheden, Leiden',
  MET:	'Metropolitan Museum of Art, New York',
  EMC:	'Egyptian Museum, Cairo',
  NMEC:	'National Museum of Egyptian Civilization',
  Louvre:	'Musée du Louvre, Paris',
  MEFirenze:	'"Museo Egizio" di Firenze',
  LACMA:	'Los Angeles County Museum of Art',
  MANN:	'Museo Archeologico Nazionale di Napoli'
};

export default class Compare {
	constructor() {
	}
	init( $data ) {
    //console.log($data)
    //
    this.data=$data;
    this.library = $('.library2');
    this.mC = $('#matchModal');
    this.mC2 = $('#matchModal2');
    this.sortColumn=0;
    this.sortDir=0;
    this.filters=['','','','','',''];
    this.currentStep=0;
    this.selectedStep1=[];
    this.selectedStep2=[];
    //
    this.setupStep();
    this.initTable();

    //
    //
	}

  show() {
    this.mC.modal();
  }

  setupStep() {
    $('.js-current-step',this.mC).text(this.currentStep+1);
    $('.js-next-step-num',this.mC).text(this.currentStep+2);
    
    if (this.currentStep==0) {
      $('.js-modal-title',this.mC).text('1- Select master coffins');
      $('.js-select-all',this.mC).hide();
      $('.js-back',this.mC).hide();
      
      $('.js-infobox-step2',this.mC).addClass('d-none');
      $('.js-infobox-step1',this.mC).show();

      $('.js-subtitle-step1',this.mC).show();
      $('.js-subtitle-step2',this.mC).hide();

      $('.js-select-all-checkbox',this.mC).prop('checked',false);
    }
    else {
      $('.js-modal-title',this.mC).text('2- Select the coffins for comparison');
      $('.js-select-all',this.mC).show();
      $('.js-back',this.mC).show();

      $('.js-infobox-step1',this.mC).hide();
      $('.js-infobox-step2',this.mC).removeClass('d-none');

      $('.js-subtitle-step1',this.mC).hide();
      $('.js-subtitle-step2',this.mC).show();
    }
  }

  initTable() {
    const tbody = $('.js-selection-table tbody',this.mC);
    const thead = $('.js-selection-table thead',this.mC);

    $('.js-button-step2',this.mC).click(()=>{
      if (this.currentStep==0) {
        this.currentStep=1;
        this.setupStep();
      }
      else if (this.currentStep==1) {
        this.mC.modal('hide');
        $('body').addClass('overflow-hidden');
        this.mC2.modal();
        this.constructResultTable();
      }
    });

    $('.js-btn-step2',this.mC2).click(()=>{
      this.mC2.modal('hide');
      this.mC.modal();
    });

    $('.js-btn-new-match',this.mC2).click(()=>{
      this.mC2.modal('hide');
      this.mC.modal();

      this.selectedStep1=[];
      this.selectedStep2=[];
      const tbody = $('.js-selection-table tbody',this.mC);
      $('.js-table-checkbox',tbody).prop('checked',false);
      this.updateSelected();
      if (this.currentStep>0) {
        this.currentStep=0;
        this.setupStep();
      }
    });
    

    $('.js-button-step1',this.mC).click(()=>{
      for (let uidsel2 of this.selectedStep2) {
        const tr = $('tr[data-uid="'+uidsel2+'"]',tbody);
        $('.js-table-checkbox',tr).prop('checked',false);
      }
      this.selectedStep2=[];
      this.updateSelected();
      this.currentStep=0;
      this.setupStep();
    });

    $('.js-reset',this.mC).click(()=>{
      this.selectedStep1=[];
      this.selectedStep2=[];
      const tbody = $('.js-selection-table tbody',this.mC);
      $('.js-table-checkbox',tbody).prop('checked',false);
      this.updateSelected();
      if (this.currentStep>0) {
        this.currentStep=0;
        this.setupStep();
      }
    });

    $('.js-select-all-checkbox',this.mC).change((ev)=>{
      const checked = $(ev.currentTarget).prop('checked');
      if (checked) {
        $('tr',tbody).each((idx,el)=>{
          if (el.style.display!=='none') {
            const uid = $(el).attr('data-uid');
            if (this.selectedStep1.indexOf(uid)===-1 && this.selectedStep2.indexOf(uid)===-1) {
              this.selectedStep2.push(uid);
              $('.js-table-checkbox',el).prop('checked',true);
            }
          }
        });
        this.updateSelected();
      }
      else {
        for (let uid of this.selectedStep2) {
          const tr = $('tr[data-uid="'+uid+'"]',this.mC);
          $('.js-table-checkbox',tr).prop('checked',false);
        }
        this.selectedStep2=[];
        this.updateSelected();
      }
    });

    $('.js-btn-delete-all',this.mC).click(()=>{
      for (let uid of this.selectedStep2) {
        const tr = $('tr[data-uid="'+uid+'"]',this.mC);
        $('.js-table-checkbox',tr).prop('checked',false);
      }
      this.selectedStep2=[];
      this.updateSelected();
    });

    $('.js-btn-delete-all',this.mC2).click(()=>{
      for (let uid of this.selectedStep2) {
        const tr = $('tr[data-uid="'+uid+'"]',this.mC);
        $('.js-table-checkbox',tr).prop('checked',false);
        this.selectedStep2=[];
        this.updateSelected();
        this.constructResultTable();
      }
    });

    $('.js-export-excel',this.mC2).click(()=>{
      // ServiceManager.standardCall('/api/exportExcel',this.resultTable,(rs)=>{});
      $('#exportForm input[name="Data"]').val(JSON.stringify(this.resultTable));
      $('#exportForm').submit();
    });
    

    let row=$('.js-table-row',this.library);
    
    for (let i = 0 ; i<this.data.length ; i++) {
      let _data = this.data[i];
      let _row = row.clone();
      _row.attr('data-uid',_data.Uid);
      if (i%2==0) {
        _row.addClass('even');
      }
      else {
        _row.addClass('odd');
      }
      _row.append($('<td></td>').text(_data.NomeEx));
      _row.append($('<td></td>').text(musei[_data.Museo]));
      _row.append($('<td></td>').text(_data.Codice));
      _row.append($('<td></td>').text(_data.NiwType));
      _row.append($('<td></td>').text(_data.Chronology));
      _row.append($('<td></td>').text(_data.Provenance));
      _row.appendTo(tbody);
    }
    $('.js-num-results',this.mC).text(this.data.length);

    $('.js-table-label',thead).click((ev)=>{
      const column = $(ev.currentTarget).closest('th').index();
      
      if (column==this.sortColumn) {
        this.sortDir++;
        if (this.sortDir>1) {
          this.sortColumn=0;
          this.sortDir=0;
        }
      }
      else {
        this.sortColumn=column;
        this.sortDir=0;
      }
      this.sort();
    })

    $('.js-table-input',thead).on('input',(ev)=>{
      $('.js-select-all-checkbox',this.mC).prop('checked',false);
      this.filter();
    })

    $('.js-table-checkbox',tbody).on('change',(ev)=>{
      const tr = $(ev.currentTarget).closest('tr')
      const uid = tr.attr('data-uid');
      const checked = $(ev.currentTarget).prop('checked');
      
      if (this.currentStep==0) {
        if (checked) {
          if (selectedColors.length>this.selectedStep1.length) {
            this.selectedStep1.push(uid);
          }
          else {
            ev.preventDefault();
            $(ev.currentTarget).prop('checked',false);
          }
        }
        else {
          const idx = this.selectedStep1.indexOf(uid);
          if (idx!=-1) {
            this.selectedStep1.splice(idx,1);
          }
        }
      }
      else if (this.currentStep==1) {
        if (this.selectedStep1.indexOf(uid)!==-1) {
          ev.preventDefault();
          $(ev.currentTarget).prop('checked',!checked);
        }
        else {
          if (checked) {
            this.selectedStep2.push(uid);
          }
          else {
            const idx = this.selectedStep2.indexOf(uid);
            if (idx!=-1) {
              this.selectedStep2.splice(idx,1);
            }
          }
        }
      }
      this.updateSelected();
      //console.log(this.selectedStep1);
    })
    
  }

  updateSelected() {
    if (this.selectedStep1.length>0) {
      $('.js-button-step2',this.mC).removeClass('disabled');
    }
    else {
      $('.js-button-step2',this.mC).addClass('disabled');
    }
    this.sort();
    this.setColors();
    this.updateInfoBox();
    this.updateInfoBox2();
  }

  setColors() {
    const tbody = $('.js-selection-table tbody',this.mC);
    $('tr',tbody).each((_idx,el)=>{
      const tr = $(el);
      const uid = tr.attr('data-uid');
      
      tr.removeClass('selected');
      for (let color of selectedColors) {
        tr.removeClass(color);
      }

      const idxselected = this.selectedStep1.indexOf(uid);
      if (idxselected!==-1) {
        const color = selectedColors[idxselected];
        tr.addClass(color);
      }

      const idxselected2 = this.selectedStep2.indexOf(uid);
      if (idxselected2!==-1) {
        tr.addClass('selected');
      }
    });
  }

  updateInfoBox() {
    const tbody = $('.js-selection-table tbody',this.mC);
    const box = $('.js-infobox-step1',this.mC);
    $('.js-info-box-numselected',box).text(this.selectedStep1.length);
    
    if (this.selectedStep1.length>0) {
      $('.js-reset',this.mC).removeClass('disabled');
      $('.js-info-box-no-selected',box).hide();
      $('.js-info-box-has-selected',box).show();
      
      if (this.selectedStep1.length===selectedColors.length) {
        $('.js-info-box-max-reached',box).show();
      }
      else {
        $('.js-info-box-max-reached',box).hide();
      }
      
      const list = $('.js-selected-list',box);
      list.html('');
      for (let i = 0; i < this.selectedStep1.length; i++) {
        const uid =  this.selectedStep1[i];
        const dataitem = this.data.find((_item)=>(_item.Uid===uid));
        const row = $('.js-info-box-row',this.library).clone();
        row.addClass(selectedColors[i])
        row.attr('data-uid',uid)
        $('.js-info-box-row-num',row).text(i+1);
        $('.js-info-box-row-name',row).text(dataitem.NomeEx);
        list.append(row);
      }
      $('.js-info-box-row-delete',list).click((ev)=>{
        const row = $(ev.currentTarget).closest('.js-info-box-row');
        const uid = row.attr('data-uid');
        const idxsel = this.selectedStep1.indexOf(uid);
        if (idxsel!==-1) {
          this.selectedStep1.splice(idxsel,1);
          const mainrow = $('tr[data-uid="'+uid+'"]',tbody);
          $('.js-table-checkbox',mainrow).prop('checked',false);
          this.updateSelected();
        }
      });
      $('.js-info-box-row-sort-up',list).click((ev)=>{
        const row = $(ev.currentTarget).closest('.js-info-box-row');
        const uid = row.attr('data-uid');
        const idxsel = this.selectedStep1.indexOf(uid);
        if (idxsel==0) return;
        this.selectedStep1.splice(idxsel, 1);
        this.selectedStep1.splice(idxsel-1, 0, uid);
        this.updateSelected();
      })
      $('.js-info-box-row-sort-down',list).click((ev)=>{
        const row = $(ev.currentTarget).closest('.js-info-box-row');
        const uid = row.attr('data-uid');
        const idxsel = this.selectedStep1.indexOf(uid);
        this.selectedStep1.splice(idxsel, 1);
        this.selectedStep1.splice(idxsel+1, 0, uid);
        this.updateSelected();
      })
    }
    else {
      $('.js-reset',this.mC).addClass('disabled');
      $('.js-info-box-no-selected',box).show();
      $('.js-info-box-has-selected',box).hide();
    }
  }

  updateInfoBox2() {
    const tbody = $('.js-selection-table tbody',this.mC);
    const box = $('.js-infobox-step2',this.mC);
    $('.js-info-box-numselected',box).text(this.selectedStep2.length);
      
    const list = $('.js-selected-list',box);
    list.html('');
    for (let i = 0; i < this.selectedStep2.length; i++) {
      const uid =  this.selectedStep2[i];
      const dataitem = this.data.find((_item)=>(_item.Uid===uid));
      const row = $('.js-info-box2-row',this.library).clone();
      row.addClass('selected')
      row.attr('data-uid',uid)
      $('.js-info-box-row-name',row).text(dataitem.NomeEx);
      list.append(row);
    }
    $('.js-info-box-row-delete',list).click((ev)=>{
      const row = $(ev.currentTarget).closest('.js-info-box2-row');
      const uid = row.attr('data-uid');
      const idxsel = this.selectedStep2.indexOf(uid);
      if (idxsel!==-1) {
        this.selectedStep2.splice(idxsel,1);
        const mainrow = $('tr[data-uid="'+uid+'"]',tbody);
        $('.js-table-checkbox',mainrow).prop('checked',false);
        this.updateSelected();
      }
    });
    $('.js-info-box-row-sort-up',list).click((ev)=>{
      const row = $(ev.currentTarget).closest('.js-info-box2-row');
      const uid = row.attr('data-uid');
      const idxsel = this.selectedStep2.indexOf(uid);
      if (idxsel==0) return;
      this.selectedStep2.splice(idxsel, 1);
      this.selectedStep2.splice(idxsel-1, 0, uid);
      this.updateSelected();
    })
    $('.js-info-box-row-sort-down',list).click((ev)=>{
      const row = $(ev.currentTarget).closest('.js-info-box2-row');
      const uid = row.attr('data-uid');
      const idxsel = this.selectedStep2.indexOf(uid);
      this.selectedStep2.splice(idxsel, 1);
      this.selectedStep2.splice(idxsel+1, 0, uid);
      this.updateSelected();
    })
    
  }

  sort() {
    const thead = $('.js-selection-table thead',this.mC);
    $('th',thead).each((idx,el)=>{
      if (idx>0) {
        const hsort = $('.js-h-sort',el);
        hsort.removeClass('fa-sort-alpha-up');
        hsort.removeClass('fa-sort-alpha-down');
        if (this.sortColumn==idx) {
          if (this.sortDir==0) {
            hsort.addClass('fa-sort-alpha-down');
          }
          else {
            hsort.addClass('fa-sort-alpha-up');
          }
        }
      }
    })
    const sorted = [...this.data].sort((a,b)=>{
      const sela=this.selectedStep1.indexOf(a.Uid);
      const selb=this.selectedStep1.indexOf(b.Uid);

      if (sela!=-1 && selb != -1) {
        if (sela<selb) return -1;
        else if (sela>selb) return 1;
        else return 0;
      }
      else if (sela!=-1) {
        return -1
      }
      else if (selb!=-1) {
        return 1;
      }

      if (this.sortColumn==0) {
        const _a = parseInt(a.Uid);
        const _b = parseInt(b.Uid);
        if (_a<_b) return -1;
        else if (a>b) return 1;
        else return 0;
      }

      let stra='';
      let strb='';
      if (this.sortColumn==1) {
        stra=a.Nome;
        strb=b.Nome;
      }
      else if (this.sortColumn==2) {
        stra=a.Museo;
        strb=b.Museo;
      }
      else if (this.sortColumn==3) {
        stra=a.Codice;
        strb=b.Codice;
      }
      else if (this.sortColumn==4) {
        stra=a.NiwType;
        strb=b.NiwType;
      }
      else if (this.sortColumn==5) {
        stra=a.Chronology;
        strb=b.Chronology;
      }
      else if (this.sortColumn==6) {
        stra=a.Provenance;
        strb=b.Provenance;
      }
      if (this.sortDir==0) {
        return (stra??'').localeCompare(strb??'');
      }
      else {
        return -(stra??'').localeCompare(strb??'');
      }
    });

    const tbody = $('.js-selection-table tbody',this.mC);
    for (let i = 0 ; i < sorted.length; i++) {
      const _current = sorted[i];
      const $c = $('tr[data-uid="'+_current.Uid+'"]',tbody);
      tbody.append($c);
    }
    this.filter();
  }

  filter() {
    const thead = $('.js-selection-table thead',this.mC);
    $('th',thead).each((idx,el)=>{
      if (idx>0) {
        const txt = $('.js-table-input',el).val();
        this.filters[idx-1]=txt;
      }
    });
    //console.log(this.filters);

    let tbody = $('.js-selection-table tbody',this.mC);
    let rownum = 0;
    $('tr',tbody).each((idx,el)=>{
      const uid = $(el).attr('data-uid');
      const ditem = this.data.find((_item)=>(_item.Uid===uid));

      let show=true;
      if (this.selectedStep1.indexOf(uid)===-1 && this.selectedStep2.indexOf(uid)===-1) {
        if (this.filters[0]) {
          if (
            !(ditem.NomeEx??'').toLowerCase().includes(this.filters[0].toLowerCase())
          ) {
            show = false;
          }
        }
        if (this.filters[1]) {
          if (
            !(musei[ditem.Museo??'']??'').toLowerCase().includes(this.filters[1].toLowerCase())
          ) {
            show = false;
          }
        }
        if (this.filters[2]) {
          if (
            !(ditem.Codice??'').toLowerCase().includes(this.filters[2].toLowerCase())
          ) {
            show = false;
          }
        }
        if (this.filters[3]) {
          if (
            !(ditem.NiwType??'').toLowerCase().includes(this.filters[3].toLowerCase())
          ) {
            show = false;
          }
        }
        if (this.filters[4]) {
          if (
            !(ditem.Chronology??'').toLowerCase().includes(this.filters[4].toLowerCase())
          ) {
            show = false;
          }
        }
        if (this.filters[5]) {
          if (
            !(ditem.Provenance??'').toLowerCase().includes(this.filters[5].toLowerCase())
          ) {
            show = false;
          }
        }
      }
      if (show) {
        $(el).show();
        if (rownum%2==0) {
          $(el).addClass('even');
          $(el).removeClass('odd');
        }
        else {
          $(el).addClass('odd');
          $(el).removeClass('even');
        }
        rownum++;
      }
      else {
        $(el).hide();
      }
    });
    $('.js-num-results',this.mC).text(rownum);
  }

  constructResultTable() {
    this.resultTable=[];

    const table = $('.js-result-table',this.mC2);
    const lrow = $('.js-result-table-row',this.library);
    table.html('');
    
    for (let i = 0; i < this.selectedStep1.length; i++) {
      const resultRow={columns:[]};

      const uid = this.selectedStep1[i];
      const data = this.data.find((_d)=>(_d.Uid===uid));
      const row=lrow.clone();
      row.attr('data-uid',uid);
      //$('.js-name',row).text(data.NomeEx).addClass(selectedColors[i]);
      $('.js-name', row)
        .html("<span>" + data.NomeEx + "</span>")
        .addClass(selectedColors[i])
        .attr("title", data.NomeEx);
      
      resultRow.columns.push({val:data.NomeEx,color:selectedColors[i]})

      $('.js-set',row).text(data.Codice);
      
      resultRow.columns.push({val:musei[data.Museo]});
      resultRow.columns.push({val:data.Codice});
      resultRow.columns.push({val:data.NiwType});
      resultRow.columns.push({val:data.Chronology});
      resultRow.columns.push({val:data.Provenance});
      
      if (!data.link) {
        $('.js-btn-external-link',row).hide();
      }
      resultRow.link=data.link;
      resultRow.pdf = '/data/repo/pdf/'+data.name+'.pdf';
      //$('.js-badge',row).addClass(selectedColors[i]);
      row.appendTo(table);
      
      for (let fn = 1; fn <= 19; fn++) {
        const col=$('.js-feature[data-fn="'+fn+'"]',row);
        const curr_feat=this.getFeature(data,fn);
        if (curr_feat===null || curr_feat==='Missing' || curr_feat==='Broken') {
          //$(missing).attr('title',curr_feat===null?'N/A':curr_feat).appendTo(col).tooltip();
          let txt='';
          if (curr_feat===null) txt='N/A';
          else if (curr_feat==='Missing') txt='M';
          else if (curr_feat==='Broken') txt='B'
          $(missing2).attr('title',curr_feat===null?'N/A':curr_feat).text(txt).appendTo(col).tooltip();
          resultRow.columns.push({'val':curr_feat===null?'N/A':curr_feat});
        }
        else {
          for (let j = 0; j <= i; j++) {
            const uid2 = this.selectedStep1[j];
            const data2 = this.data.find((_d)=>(_d.Uid===uid2));
            const comp_feat = this.getFeature(data2,fn);

            if (curr_feat===comp_feat) {
              col.addClass(selectedColors[j]);
              resultRow.columns.push({'val':curr_feat, color:selectedColors[j],name:this.getFeatureName(fn)});
              break;
            }
          }
        }
      }
      $('.js-badge-text',row).text(data.Match);
      $('.js-badge',row).show();
      
      resultRow.columns.push({val:data.Match})

      this.resultTable.push(resultRow);
    }
    
    for (let i = 0; i < this.selectedStep2.length; i++) {
      const resultRow={columns:[]};

      const uid = this.selectedStep2[i];
      const data = this.data.find((_d)=>(_d.Uid===uid));
      const row=lrow.clone();
      row.attr('data-uid',uid);
      $('.js-name-txt',row).text(data.NomeEx);
      $('.js-name-txt',row).attr('title',data.NomeEx);

      resultRow.columns.push({val:data.NomeEx})

      $('.js-set',row).text(data.Codice);
      
      resultRow.columns.push({val:musei[data.Museo]});
      resultRow.columns.push({val:data.Codice});
      resultRow.columns.push({val:data.NiwType});
      resultRow.columns.push({val:data.Chronology});
      resultRow.columns.push({val:data.Provenance});

      if (!data.link) {
        $('.js-btn-external-link',row).hide();
      }
      resultRow.link=data.link;
      resultRow.pdf = '/data/repo/pdf/'+data.name+'.pdf';
      
      row.appendTo(table);

      const matches=[];
      for (let j = 0; j < this.selectedStep1.length; j++) {
        matches.push(0);
      }

      for (let fn = 1; fn <= 19; fn++) {
        const col=$('.js-feature[data-fn="'+fn+'"]',row);
        const curr_feat=this.getFeature(data,fn);
        if (curr_feat===null || curr_feat==='Missing' || curr_feat==='Broken') {
          //$(missing).attr('title',curr_feat===null?'N/A':curr_feat).appendTo(col).tooltip();
          let txt='';
          if (curr_feat===null) txt='N/A';
          else if (curr_feat==='Missing') txt='M';
          else if (curr_feat==='Broken') txt='B'
          $(missing2).attr('title',curr_feat===null?'N/A':curr_feat).text(txt).appendTo(col).tooltip();
 
          resultRow.columns.push({'val':curr_feat===null?'N/A':curr_feat});
        }
        else {
          const column={val:curr_feat, name:this.getFeatureName(fn)};
          for (let j = 0; j < this.selectedStep1.length; j++) {
            const uid2 = this.selectedStep1[j];
            const data2 = this.data.find((_d)=>(_d.Uid===uid2));
            const comp_feat = this.getFeature(data2,fn);

            if (curr_feat===comp_feat) {
              col.addClass(selectedColors[j]);
              column.color=selectedColors[j];
              matches[j]++;
              break;
            }
          }
          resultRow.columns.push(column);
        }
      }
      $('.js-badge-text',row).text(data.Match);
      $('.js-badge',row).show();

      const maxm=indexOfMax(matches);
      if (maxm>-1 && matches[maxm]>0) {
        $('.js-badge',row).addClass(selectedColors[maxm]);
        const dataMatch = this.data.find((_d)=>(_d.Uid===this.selectedStep1[maxm]));
        let eq = 0;
        for (let _fn = 1 ; _fn <= 19; _fn++) {
          const datamf= this.getFeature(dataMatch,_fn);
          const dataf= this.getFeature(data,_fn);
          if (dataf!==null&&dataf!=='Missing' && dataf!=='Broken'&&
            datamf!==null&&datamf!=='Missing' && datamf!=='Broken'&&
            datamf===dataf
          ){
            eq++;
          }
        }
        const title = matchTitle.replace('{NomeEx}',dataMatch.NomeEx).replace('{MatchNum}',eq);
        $('.js-badge',row).attr('title',title);
        $('.js-badge',row).tooltip();

        resultRow.columns.push({val:data.Match,color:selectedColors[maxm]})
      }
      else {
        resultRow.columns.push({val:data.Match})
      }

      this.resultTable.push(resultRow);
    }

    $('.js-btn-download-pdf',table).click((ev)=>{
      const uid = $(ev.currentTarget).closest('.js-result-table-row').attr('data-uid');
      const data = this.data.find((_d)=>(_d.Uid===uid));
      window.open('/data/repo/pdf/'+data.name+'.pdf',"_blank")
    });
    $('.js-btn-download-pdf',table).tooltip();

    $('.js-btn-external-link',table).click((ev)=>{
      const uid = $(ev.currentTarget).closest('.js-result-table-row').attr('data-uid');
      const data = this.data.find((_d)=>(_d.Uid===uid));
      window.open(data.link,"_blank");
    });
    $('.js-btn-external-link',table).tooltip();
    //console.log(this.resultTable);
    this.updateInfoBoxStep3();
    this.updateInfoBox2Step3();
  }

  updateInfoBoxStep3() {
    const tbody = $('.js-selection-table tbody',this.mC);
    const box = $('.js-infobox-step1',this.mC2);
    $('.js-info-box-numselected',box).text(this.selectedStep1.length);
    
    if (this.selectedStep1.length>0) {
      $('.js-reset',this.mC2).removeClass('disabled');
      $('.js-info-box-no-selected',box).hide();
      $('.js-info-box-has-selected',box).show();
      
      if (this.selectedStep1.length===selectedColors.length) {
        $('.js-info-box-max-reached',box).show();
      }
      else {
        $('.js-info-box-max-reached',box).hide();
      }
      
      const list = $('.js-selected-list',box);
      list.html('');
      for (let i = 0; i < this.selectedStep1.length; i++) {
        const uid =  this.selectedStep1[i];
        const dataitem = this.data.find((_item)=>(_item.Uid===uid));
        const row = $('.js-info-box-row',this.library).clone();
        row.addClass(selectedColors[i])
        row.attr('data-uid',uid)
        $('.js-info-box-row-num',row).text(i+1);
        $('.js-info-box-row-name',row).text(dataitem.NomeEx);
        list.append(row);
      }
      $('.js-info-box-row-delete',list).click((ev)=>{
        const row = $(ev.currentTarget).closest('.js-info-box-row');
        const uid = row.attr('data-uid');
        const idxsel = this.selectedStep1.indexOf(uid);
        if (idxsel!==-1) {
          this.selectedStep1.splice(idxsel,1);
          const mainrow = $('tr[data-uid="'+uid+'"]',tbody);
          $('.js-table-checkbox',mainrow).prop('checked',false);
          this.updateSelected();
          this.constructResultTable();
        }
      });
      $('.js-info-box-row-sort-up',list).click((ev)=>{
        const row = $(ev.currentTarget).closest('.js-info-box-row');
        const uid = row.attr('data-uid');
        const idxsel = this.selectedStep1.indexOf(uid);
        if (idxsel==0) return;
        this.selectedStep1.splice(idxsel, 1);
        this.selectedStep1.splice(idxsel-1, 0, uid);
        this.updateSelected();
        this.constructResultTable();
      })
      $('.js-info-box-row-sort-down',list).click((ev)=>{
        const row = $(ev.currentTarget).closest('.js-info-box-row');
        const uid = row.attr('data-uid');
        const idxsel = this.selectedStep1.indexOf(uid);
        this.selectedStep1.splice(idxsel, 1);
        this.selectedStep1.splice(idxsel+1, 0, uid);
        this.updateSelected();
        this.constructResultTable();
      })
    }
    else {
      $('.js-reset',this.mC2).addClass('disabled');
      $('.js-info-box-no-selected',box).show();
      $('.js-info-box-has-selected',box).hide();
    }
  }

  updateInfoBox2Step3() {
    const tbody = $('.js-selection-table tbody',this.mC);
    const box = $('.js-infobox-step2',this.mC2);
    $('.js-info-box-numselected',box).text(this.selectedStep2.length);
      
    const list = $('.js-selected-list',box);
    list.html('');
    for (let i = 0; i < this.selectedStep2.length; i++) {
      const uid =  this.selectedStep2[i];
      const dataitem = this.data.find((_item)=>(_item.Uid===uid));
      const row = $('.js-info-box2-row',this.library).clone();
      row.addClass('selected')
      row.attr('data-uid',uid)
      $('.js-info-box-row-name',row).text(dataitem.NomeEx);
      list.append(row);
    }
    $('.js-info-box-row-delete',list).click((ev)=>{
      const row = $(ev.currentTarget).closest('.js-info-box2-row');
      const uid = row.attr('data-uid');
      const idxsel = this.selectedStep2.indexOf(uid);
      if (idxsel!==-1) {
        this.selectedStep2.splice(idxsel,1);
        const mainrow = $('tr[data-uid="'+uid+'"]',tbody);
        $('.js-table-checkbox',mainrow).prop('checked',false);
        this.updateSelected();
        this.constructResultTable();
      }
    });
    $('.js-info-box-row-sort-up',list).click((ev)=>{
      const row = $(ev.currentTarget).closest('.js-info-box2-row');
      const uid = row.attr('data-uid');
      const idxsel = this.selectedStep2.indexOf(uid);
      if (idxsel==0) return;
      this.selectedStep2.splice(idxsel, 1);
      this.selectedStep2.splice(idxsel-1, 0, uid);
      this.updateSelected();
      this.constructResultTable();
    })
    $('.js-info-box-row-sort-down',list).click((ev)=>{
      const row = $(ev.currentTarget).closest('.js-info-box2-row');
      const uid = row.attr('data-uid');
      const idxsel = this.selectedStep2.indexOf(uid);
      this.selectedStep2.splice(idxsel, 1);
      this.selectedStep2.splice(idxsel+1, 0, uid);
      this.updateSelected();
      this.constructResultTable();
    })
    
  }

  getFeature(data,fn) {
    if (fn==1) return data['VA_Wig'];
    else if (fn==2) return data['VA_Breasts'];
    else if (fn==3) return data['VA_Eyebrow'];
    else if (fn==4) return data['VA_Eye'];
    else if (fn==5) return data['VA_Mouth'];
    else if (fn==6) return data['VA_EarEarr'];
    else if (fn==7) return data['VA_Forearms'];
    else if (fn==8) return data['VA_Hands'];
    else if (fn==9) return data['PG_Face'];
    else if (fn==10) return data['PG_Wig'];
    else if (fn==11) return data['PG_Breasts'];
    else if (fn==12) return data['PG_Eyebrow'];
    else if (fn==13) return data['PG_Eye'];
    else if (fn==14) return data['PG_Nose'];
    else if (fn==15) return data['PG_Mouth'];
    else if (fn==16) return data['PG_EarEarrings'];
    else if (fn==17) return data['PG_Forearms'];
    else if (fn==18) return data['PG_Hands'];
    else if (fn==19) return data['PG_FormBelly'];
  }

  getFeatureName(fn) {
    if (fn==1) return 'VA_Wig';
    else if (fn==2) return 'VA_Breasts';
    else if (fn==3) return 'VA_Eyebrow';
    else if (fn==4) return 'VA_Eye';
    else if (fn==5) return 'VA_Mouth';
    else if (fn==6) return 'VA_EarEarr';
    else if (fn==7) return 'VA_Forearms';
    else if (fn==8) return 'VA_Hands';
    else if (fn==9) return 'PG_Face';
    else if (fn==10) return 'PG_Wig';
    else if (fn==11) return 'PG_Breasts';
    else if (fn==12) return 'PG_Eyebrow';
    else if (fn==13) return 'PG_Eye';
    else if (fn==14) return 'PG_Nose';
    else if (fn==15) return 'PG_Mouth';
    else if (fn==16) return 'PG_EarEarrings';
    else if (fn==17) return 'PG_Forearms';
    else if (fn==18) return 'PG_Hands';
    else if (fn==19) return 'PG_FormBelly';
  }
  

	get isHomepage() {
		return true;
	}
}

function indexOfMax(arr) {
  if (arr.length === 0) {
      return -1;
  }

  var max = arr[0];
  var maxIndex = 0;

  for (var i = 1; i < arr.length; i++) {
      if (arr[i] > max) {
          maxIndex = i;
          max = arr[i];
      }
  }

  return maxIndex;
}